import React from 'react';
import { Box } from '@mui/material';
import { Head } from 'components/Head';

import { ContentHeader } from './ContentHeader';
import { CompanySwitchedBanner } from './CompanySwitchedBanner';
import { LAYOUT } from '../config';

import { PremiumBanner } from '../../../features/subscriptions/components/PremiumBanner';
import { useAuth } from 'lib/auth';
// import zIndex from '@mui/material/styles/zIndex';

export const ContentLayout = ({
  title = 'Delegon',
  headerSize = 'small',
  meta = [],
  children,
  showHeader = true,
  parentSx = {},
  sx = {},
}) => {
  const {  account, user } = useAuth();
  return (
    <>
      <Head title={title} meta={meta} />
      <Box
        display="flex"
        flexDirection="column"
        flex="1 100%"
        width={1}
        bgcolor="background.default"
        paddingBottom={5}
        sx={{...parentSx}}
      >
        {/* {!account.super_admin && user.Company.subscription_level !== "gold" && (
          <Box>
            <PremiumBanner sx={{mt:0, position:"fixed", width:"100vw", zIndex:100, left: 0}} message={`Read more about our Premium offerings here`} currentLevel={user.Company.subscription_level} showLock={false} />
          </Box>
        )} */}
        <ContentHeader headerSize={headerSize} superAdmin={account?.super_admin} subscription_level={user?.Company?.subscription_level} showHeader={showHeader} />
        <Box
          // pt={(account.super_admin || user.Company.subscription_level === 'gold') ? `${LAYOUT.smallHeaderHeight}` : `calc(${LAYOUT.smallHeaderHeight} + 52px)`}
          pt={LAYOUT.smallHeaderHeight}
          flex={1}
          width={LAYOUT.width}
          margin="auto"
          sx={{...sx}}
        >
          <CompanySwitchedBanner />
          {children}
        </Box>
      </Box>
    </>
  );
};
